const init = { materials:[], loading:false, error:null };
export const studyMaterialReducer = (state=init, action) => {
  switch(action.type) {
    case "MATERIALS_REQUEST": return { ...state, loading:true };
    case "MATERIALS_SUCCESS": return { ...state, loading:false, materials: action.payload };
    case "MATERIALS_FAIL":    return { ...state, loading:false, error: action.payload };
    default: return state;
  }
};
